export default {
    fields: [
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
        },
        {
            key: "field_id",
            label: "internal_field",
            sorter: false,
            filter: false,
        },
        {
            key: "mapping",
            label: "origin_mapping",
            sorter: false,
            filter: false,
        },
        /* {
            key: "field_type",
            label: "filter_verification",
            sorter: false,
            filter: false,
        },
        {
            key: "field_format",
            label: "format",
            sorter: false,
            filter: false,
        }, */
        {
            key: "default_value",
            label: "default_value",
            sorter: false,
            filter: false,
        },
        {
            key: "required",
            label: "required",
            _classes: "text-center",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label: "options",
            _classes: "text-center",
            _style: "width:10%",
            sorter: false,
            filter: false,
        },
    ],
    items: [],
}